import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./auth";
import { BRAND } from "../config/brand";

const BrandingContext = createContext(null);

const DEFAULT_ACCENT = "#FF2A00";

export function BrandingProvider({ children }) {
    const { user } = useAuth();
    const [company, setCompany] = useState(null);
    const [loading, setLoading] = useState(true);

    const reload = useCallback(async () => {
        if (!user) {
            setCompany(null);
            setLoading(false);
            return;
        }
        try {
            const r = await api.get("/companies/me");
            setCompany(r.data || null);
        } catch {
            setCompany(null);
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        reload();
    }, [reload]);

    useEffect(() => {
        const accent = company?.accent_color || DEFAULT_ACCENT;
        document.documentElement.style.setProperty("--signal", accent);
        // Platform title is fixed, not per-tenant (until Enterprise white-label)
        document.title = BRAND.name;
    }, [company]);

    const value = {
        company,
        loading,
        reload,
        accent_color: company?.accent_color || DEFAULT_ACCENT,
        logo_b64: company?.logo_b64 || null,
    };

    return (
        <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>
    );
}

export function useBranding() {
    const ctx = useContext(BrandingContext);
    if (!ctx) throw new Error("useBranding must be used within BrandingProvider");
    return ctx;
}
